import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import { hideToast, useToastSliceSelector } from '../../store/modules/toast';
import closeBtnImg from '../../img/dlg_close02.png';
import closeBtnImg2x from '../../img/dlg_close02@2x.png';
import { fadeIn, fadeOut, wrapWithAnimation } from './AnimationCommon';

import useDelayHiding from '../../hooks/delayHidingHook';

const ANIMATION_DURATION = 500;

export const TOAST_ALIGN = {
  BOTTOM: 'bottom'
};

const ToastContainer = wrapWithAnimation(
  styled.div`
    width: fit-content;
    position: absolute;
    background: #303338;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #ffffff;
    font-size: 15px;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    font-weight: 400;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    z-index: 9999;
    //box-sizing: border-box;

    ${({ align }) => {
      if (align === TOAST_ALIGN.BOTTOM) {
        return css`
          bottom: 90px;
          top: unset;
        `;
      }
    }};
  `,
  {
    showAni: fadeIn,
    hideAni: fadeOut,
    duration: ANIMATION_DURATION
  }
);

const CloseBtn = styled.a`
  margin-left: 12px;
  display: inline-flex;
`;

function Toast() {
  const toastState = useToastSliceSelector();
  const dispatch = useDispatch();
  const renderable = useDelayHiding(toastState.isShow, { duration: ANIMATION_DURATION });

  return (
    renderable && (
      <ToastContainer show={toastState.isShow} align={toastState.align}>
        <span dangerouslySetInnerHTML={{ __html: toastState.msg }}></span>
        <CloseBtn
          href="#test"
          onClick={(e) => {
            e.preventDefault();
            dispatch(hideToast());
          }}>
          <img
            width="24px"
            height="24px"
            src={closeBtnImg}
            srcSet={closeBtnImg2x}
            alt="close Button"
          />
        </CloseBtn>
      </ToastContainer>
    )
  );
}

export default Toast;
